var messages = require('../components/messages');
var preloader = require('../components/preloader');

var address_proto = require('../components/address_proto');

var PublicData = function () {
    var self = this;

    this.states_list = ko.observableArray();
    this.references_list = ko.observableArray();
    this.vm = null;

    this.api = {
        publicData: function (callback) {
            preloader.show('public-data');
            $.ajax({
                url: 'rest.php/public_data',
                method: 'GET',
                dataType: 'json'
            }).done(function (resp) {
                if (callback) callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('public-data');
            });
        }
    };

    this.init = function (vm, callback) {
        self.vm = vm;

        self.api.publicData(function (status, data) {
            if (!status) return;

            self.vm.captcha(data.captcha);

            address_proto.setStatesList(data.states_list);
            address_proto.setReferencesList(data.references_list);

            self.states_list(data.states_list || []);
            self.references_list(data.references_list || []);

            callback();
        });
    };
};

module.exports = new PublicData();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/services/publicData.js
// module id = 8
// module chunks = 0